export const getText = (value, lang = "ar") => {
  if (!value) return "";
  if (typeof value === "string") return value;

  return value?.[lang] || value?.ar || value?.en || "";
};

export const normalizeCategories = (res) => {
  if (Array.isArray(res)) return res;
  if (Array.isArray(res?.data)) return res.data;
  if (Array.isArray(res?.data?.data)) return res.data.data;

  return [];
};

export const buildCustomFields = (formValues) => {
  return Object.keys(formValues || {}).reduce((acc, key) => {
    acc[key] = formValues[key];
    return acc;
  }, {});
};

export const getFieldValue = (values, possibleKeys = []) => {
  for (const key of possibleKeys) {
    if (values?.[key]) return values[key];
  }

  return "";
};

export const normalizeTickets = (res) => {
  if (Array.isArray(res)) return res;
  if (Array.isArray(res?.data)) return res.data;
  if (Array.isArray(res?.data?.data)) return res.data.data;
  if (Array.isArray(res?.supports)) return res.supports;
  if (Array.isArray(res?.tickets)) return res.tickets;

  return [];
};
